const urbanSoccerCenters = [
  { name: "UrbanSoccer Angers", code: "USC-ANGERS" },
  { name: "UrbanSoccer Asnières", code: "USC-ASNIERES" },
  { name: "UrbanSoccer Avignon", code: "USC-AVIGNON" },
  { name: "UrbanSoccer Bordeaux-Mérignac", code: "USC-BORDEAUX-MERIGNAC" },
  { name: "UrbanSoccer Bordeaux-Pessac", code: "USC-BORDEAUX-PESSAC" },
  { name: "UrbanSoccer Clermont-Aubière", code: "USC-CLERMONT-AUBIERE" },
  { name: "UrbanSoccer Dijon", code: "USC-DIJON" },
  { name: "UrbanSoccer Evry-Courcouronnes", code: "USC-EVRY-COURCOURONNES" },
  { name: "UrbanSoccer Grenoble", code: "USC-GRENOBLE" },
  { name: "UrbanSoccer Guyancourt", code: "USC-GUYANCOURT" },
  { name: "UrbanSoccer La Défense", code: "USC-LA-DEFENSE" },
  { name: "UrbanSoccer Le Mans", code: "USC-LE-MANS" },
  { name: "UrbanSoccer Lille-Bondues", code: "USC-LILLE-BONDUES" },
  { name: "UrbanSoccer Lille-Lezennes", code: "USC-LILLE-LEZENNES" },
  { name: "UrbanSoccer Lyon-Barolles", code: "USC-LYON-BAROLLES" },
  { name: "UrbanSoccer Lyon-Dardilly", code: "USC-LYON-DARDILLY" },
  { name: "UrbanSoccer Lyon-Parilly", code: "USC-LYON-PARILLY" },
  { name: "UrbanSoccer Marne la Vallée", code: "USC-MARNE-LA-VALLEE" },
  { name: "UrbanSoccer Meudon", code: "USC-MEUDON" },
  { name: "UrbanSoccer Montpellier", code: "USC-MONTPELLIER" },
  {
    name: "UrbanSoccer Nantes Saint-Sébastien",
    code: "USC-NANTES-SAINT-SEBASTIEN",
  },
  { name: "UrbanSoccer Nantes Carquefou", code: "USC-NANTES-CARQUEFOU" },
  { name: "UrbanSoccer Orsay", code: "USC-ORSAY" },
  {
    name: "UrbanSoccer Porte d'Aubervilliers",
    code: "USC-PORTE-DAUBERVILLIERS",
  },
  { name: "UrbanSoccer Puteaux-Île", code: "USC-PUTEAUX-ILE" },
  { name: "UrbanSoccer Puteaux-République", code: "USC-PUTEAUX-REPUBLIQUE" },
  { name: "UrbanSoccer Quai d'Ivry", code: "USC-QUAI-D-IVRY" },
  { name: "UrbanSoccer Rennes-Cap Malo", code: "USC-RENNES-CAP-MALO" },
  { name: "UrbanSoccer Rennes-Vern", code: "USC-RENNES-VERN" },
  { name: "UrbanSoccer Saint-Étienne", code: "USC-SAINT-ETIENNE" },
  { name: "UrbanSoccer Strasbourg", code: "USC-STRASBOURG" },
  { name: "UrbanSoccer Toulouse-Montaudran", code: "USC-TOULOUSE-MONTAUDRAN" },
  {
    name: "UrbanSoccer Toulouse-Sept Deniers",
    code: "USC-TOULOUSE-SEPT-DENIERS",
  },
  { name: "UrbanSoccer Villeneuve-Loubet", code: "USC-VILLENEUVE-LOUBET" },
];

const leFiveCenters = [
  { name: "LE FIVE Bezons", code: "LFVBENS" },
  { name: "LE FIVE Bobigny", code: "LFVBONY" },
  { name: "LE FIVE Carrières-sous-Poissy", code: "LFVCARSY" },
  { name: "LE FIVE Champigny", code: "LFVCHNY" },
  { name: "LE FIVE Créteil", code: "LFVCRIL" },
  { name: "LE FIVE Marville", code: "LFVMALE" },
  { name: "LE FIVE Montreuil", code: "LFVMOIL" },
  { name: "LE FIVE Morangis", code: "LFVMORS" },
  { name: "LE FIVE Paris 13", code: "LFVPA13" },
  { name: "LE FIVE Paris 17", code: "LFVPA17" },
  { name: "LE FIVE Paris 18", code: "LFVPA18" },
  { name: "LE FIVE Villette", code: "LFVVITE" },
  { name: "LE FIVE Dunkerque", code: "LFVDUNK" },
  { name: "LE FIVE Lens-Lievin", code: "LFVLENS" },
  { name: "LE FIVE Valenciennes", code: "LFVVALS" },
  { name: "LE FIVE Metz", code: "LFVMETZ" },
  { name: "LE FIVE Mulhouse", code: "LFVMULH" },
  { name: "LE FIVE Nancy", code: "LFVNANC" },
  { name: "LE FIVE Reims", code: "LFVREIM" },
  { name: "LE FIVE Saint-Louis - Bâle", code: "LFVSLBA" },
  { name: "LE FIVE Orléans Fleury", code: "LFVORFL" },
  { name: "LE FIVE Orléans Ingré", code: "LFVORIN" },
  { name: "LE FIVE Annemasse", code: "LFVANNE" },
  { name: "LE FIVE OL - Lyon", code: "LFVOLLY" },
  { name: "LE FIVE Bordeaux", code: "LFVBORD" },
  { name: "LE FIVE Limoges", code: "LFVLIMO" },
  { name: "LE FIVE Pau", code: "LFVPAU" },
  { name: "LE FIVE Saint-Louis - La Réunion", code: "LFVSLRE" },
  { name: "LE FIVE Challans", code: "LFVCHAL" },
  { name: "LE FIVE Rouen", code: "LFVROUE" },
];

const centers = [...leFiveCenters, ...urbanSoccerCenters];

const days = [
  { name: "Lundi", code: "MON" },
  { name: "Mardi", code: "TUE" },
  { name: "Mercredi", code: "WED" },
  { name: "Jeudi", code: "THU" },
  { name: "Vendredi", code: "FRI" },
  { name: "Samedi", code: "SAT" },
  { name: "Dimanche", code: "SUN" },
];

const hours = [
  { name: "07:00", code: "07:00:00" },
  { name: "07:30", code: "07:30:00" },
  { name: "08:00", code: "08:00:00" },
  { name: "08:30", code: "08:30:00" },
  { name: "09:00", code: "09:00:00" },
  { name: "09:30", code: "09:30:00" },
  { name: "10:00", code: "10:00:00" },
  { name: "10:30", code: "10:30:00" },
  { name: "11:00", code: "11:00:00" },
  { name: "11:30", code: "11:30:00" },
  { name: "12:00", code: "12:00:00" },
  { name: "12:30", code: "12:30:00" },
  { name: "13:00", code: "13:00:00" },
  { name: "13:30", code: "13:30:00" },
  { name: "14:00", code: "14:00:00" },
  { name: "14:30", code: "14:30:00" },
  { name: "15:00", code: "15:00:00" },
  { name: "15:30", code: "15:30:00" },
  { name: "16:00", code: "16:00:00" },
  { name: "16:30", code: "16:30:00" },
  { name: "17:00", code: "17:00:00" },
  { name: "17:30", code: "17:30:00" },
  { name: "18:00", code: "18:00:00" },
  { name: "18:30", code: "18:30:00" },
  { name: "19:00", code: "19:00:00" },
  { name: "19:30", code: "19:30:00" },
  { name: "20:00", code: "20:00:00" },
  { name: "20:30", code: "20:30:00" },
  { name: "21:00", code: "21:00:00" },
  { name: "21:30", code: "21:30:00" },
  { name: "22:00", code: "22:00:00" },
  { name: "22:30", code: "22:30:00" },
  { name: "23:00", code: "23:00:00" },
  { name: "23:30", code: "23:30:00" },
];

export { centers, days, hours };
